// PrivateRoute.jsx
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  return token === "hardcoded-token" ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
